import { DashboardResponse } from '@interfaces/models';
import { httpClient } from '@api/interceptors';

export async function getDashboard(): Promise<DashboardResponse> {
  return httpClient.get<DashboardResponse>('dashboard').json();
}
